import { render, staticRenderFns } from "./ExchangeHistory.vue?vue&type=template&id=b4288b1e"
import script from "./ExchangeHistory.vue?vue&type=script&lang=js"
export * from "./ExchangeHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4288b1e')) {
      api.createRecord('b4288b1e', component.options)
    } else {
      api.reload('b4288b1e', component.options)
    }
    module.hot.accept("./ExchangeHistory.vue?vue&type=template&id=b4288b1e", function () {
      api.rerender('b4288b1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ExchangeHistory.vue"
export default component.exports